const apiMessages = {
	error: "Sorry, we've encountered an error! Please try your request again."
};

export default apiMessages;
